import axios from 'axios'
import { getToken } from '../auth'
import { config } from '../config'

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 5000,
})

client.interceptors.request.use(req => {
  if (config.shouldSkipAuth) return req

  const token = getToken()
  if (token) {
    req.headers['Authorization'] = `Bearer ${token}`
  }
  return req
}, error => {
  if (error.response.status === 401) {
    window.location.replace('/')
  }
  return error
})
